import React from 'react';

const PublicFormContext = React.createContext({public: false, entityType: null});

export default PublicFormContext